import { render, staticRenderFns } from "./ResourcesExplorer.vue?vue&type=template&id=23975de0&scoped=true"
import script from "./ResourcesExplorer.vue?vue&type=script&lang=js"
export * from "./ResourcesExplorer.vue?vue&type=script&lang=js"
import style0 from "./ResourcesExplorer.vue?vue&type=style&index=0&id=23975de0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23975de0",
  null
  
)

export default component.exports